<script>
	import { onMount } from 'svelte'
	import { fade, fly } from 'svelte/transition'

	const { $: jQuery } = window

	let shown = false
	let job = {
		title: 'Superintendent',
		type_of_job: 'FULL-TIME',
		body: 'description',
		button_title: 'Apply Now',
		button_url: 'https://www.indeed.com/cmp/Christel-Construction',
		button_target: '_blank',
	}

	let html

	const closePopup = () => {
		html.classList.remove('show-modal')
		shown = false
	}
	const wrapClick = (e) => e.target === e.currentTarget && closePopup()

	onMount(() => {
		html = document.getElementsByTagName('html')[0]
		jQuery('.jobs-item .btn-content').on('click', (e) => {
			job = jQuery(e.currentTarget).data('job')
			html.classList.add('show-modal')
			if (job.body) {
				shown = true
			}
		})
	})

	$: console.log('job:', job)
</script>

<svelte:window on:keyup={(e) => e.keyCode === 27 && closePopup()} />

{#if shown && job}
	<div
		class="team-popup-wrap job-popup-wrap"
		on:click={wrapClick}
		transition:fade={{ duration: 300 }}
	>
		<div class="main" on:click={wrapClick}>
			<div class="inner-wrap" in:fly={{ y: 15 }} out:fly={{ y: -15 }}>
				<div class="team-popup">
					<!-- job info -->
					<div class="popup-inner">
						<div class="tp-row">
							<div class="tp-content">
								<div class="tp-meta">
									<h2>{job.title}</h2>
								</div>
								<div>
									<p><a href="{job.button_url}" class="btn"><span style="padding:20px;">Apply Online</span></a></p>

									{@html job.body}
									<p><a href="{job.button_url}" class="btn"><span style="padding:20px;">Apply Online</span></a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button class="close-popup" on:click={closePopup}>
					<span>&times;</span>
				</button>
			</div>
		</div>
	</div>
{/if}

<style type="text/scss">
	.main {
		align-self: center;
		width: unset;
		height: 100%;
		margin: auto;
	}
	
</style>
